import React from "react";
import { CircularProgress } from "@mui/material";

const PageSpinner = ({ fullScreen = false }) => (
  <div
    className={`flex w-full items-center justify-center ${
      fullScreen ? "h-screen" : "min-h-[300px] py-16"
    }`}
  >
    <CircularProgress />
  </div>
);

export default PageSpinner;
